(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-facets-toggle')) {
    class StickyFacetsToggle extends HTMLElement {
      constructor() {
        super();

        this.button = null;
        this.anchor = null;
        this.placeholder = null;
        this.isFixed = false;

        this.handleIntersect = this.handleIntersect.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.scrollTimeout = null;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        // Disabled bottom fixed behavior on scroll for mobile
        return;
      }

      handleIntersect(entries) {
        const entry = entries[0];

        if (entry.isIntersecting) {
          this.unfix();
        } else {
          this.fix();
        }
      }

      handleScroll() {
        if (this.scrollTimeout) {
          clearTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(() => {
          const anchorRect = this.anchor.getBoundingClientRect();
          const hasFixedClass = this.button.classList.contains('facets-toggle--fixed');
          if (anchorRect.bottom < 0 && !hasFixedClass) {
            this.fix();
          } else if (anchorRect.top >= 0 && hasFixedClass) {
            this.unfix();
          }
        }, 10);
      }

      fix() {
        if (this.isFixed) return;

        const height = this.button.offsetHeight;
        this.placeholder.style.height = `${height}px`;
        this.placeholder.style.display = 'block';

        this.button.classList.add('facets-toggle--fixed');
        this.isFixed = true;
      }

      unfix() {
        if (!this.isFixed) return;

        this.button.classList.remove('facets-toggle--fixed');
        this.placeholder.style.display = 'none';
        this.isFixed = false;
      }

      handleResize() {
        if (this.isFixed) {
          this.placeholder.style.height = `${this.button.offsetHeight}px`;
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.scrollTimeout) {
          clearTimeout(this.scrollTimeout);
        }
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
      }
    }

    customElements.define('sticky-facets-toggle', StickyFacetsToggle);
  }
  } catch(e) { console.error(e); }
})();

})();
